import React from "react";
import {
  MinersCard,
  MinersCardContainer,
  MinersCardImg,
  MinersOwnedContainer,
  MinersValueText,
} from "./MinersOwned.styled";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getMinersOwned } from "../../feature/minersOwned/MinersOwnedActions";
import { useNavigate } from "react-router-dom";

const MinersOwned = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { minersOwned } = useSelector((state) => state.minersOwned);
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    Object.keys(user).length && dispatch(getMinersOwned({ user: user }));
  }, [dispatch, user]);

  return (
    <MinersOwnedContainer>
      <MinersCardContainer>
        {minersOwned &&
          minersOwned.map((data, index, row) => (
            <MinersCard key={index}>
              <div>
                <MinersCardImg
                  alt={`Miners${data.machine_set.id}`}
                  src={data.machine_set.image}
                />
                <div>
                  Revenue:{" "}
                  <MinersValueText>
                    {data.machine_set.daily_profit} TRX
                  </MinersValueText>
                </div>
                <div>
                  Owned: <MinersValueText>{data.quantity}</MinersValueText>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div>
                  <div>{data.machine_set.name}</div>
                  <MinersValueText style={{ marginBottom: "5px" }}>
                    {data.machine_set.price} TRX
                  </MinersValueText>
                </div>
                <div>
                  <div>1 year profit</div>
                  <MinersValueText style={{ marginBottom: "5px" }}>
                    {data.machine_set.earning_sequence === 12
                      ? `${(data.machine_set.daily_profit * 2 * 365).toFixed(
                          2
                        )} TRX`
                      : `${(data.machine_set.daily_profit * 365).toFixed(
                          2
                        )} TRX`}
                  </MinersValueText>
                </div>
                <div>
                  <div>30 days profit</div>
                  <MinersValueText style={{ marginBottom: "5px" }}>
                    {data.machine_set.earning_sequence === 12
                      ? `${(data.machine_set.daily_profit * 2 * 30).toFixed(
                          2
                        )} TRX`
                      : `${(data.machine_set.daily_profit * 30).toFixed(
                          2
                        )} TRX`}
                  </MinersValueText>
                </div>
                <div>
                  <div>Earning cycle</div>
                  <MinersValueText style={{ marginBottom: "5px" }}>
                    {data.machine_set.earning_sequence} hour
                  </MinersValueText>
                </div>
                {data.is_activated ? (
                  <button
                    style={{ height: "30px", marginBlockStart: "10px" }}
                    onClick={() => {
                      navigate("/sell-miner", { state: { data } });
                    }}
                  >
                    Sell
                  </button>
                ) : (
                  <button
                    style={{ height: "30px", marginBlockStart: "10px" }}
                    onClick={() => {
                      navigate("/re-activate-miner", {
                        state: { selectedMachine: data.machine_set, data },
                      });
                    }}
                  >
                    Re-Activate Miner
                  </button>
                )}
              </div>
            </MinersCard>
          ))}
      </MinersCardContainer>
    </MinersOwnedContainer>
  );
};

export default MinersOwned;
